/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import styled from "styled-components";
import { theme } from "@nordcloud/gnui";
import { Box, BoxProps } from "./Box";

const InnerBox = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 2rem;
`;

type Props = Omit<BoxProps, "color" | "margin" | "size" | "inline"> & {
  children: React.ReactNode;
  onClick: () => void;
};

export function IconWrap({ children, onClick, ...props }: Props) {
  return (
    <Box
      color={theme.color.background.ui03}
      margin=".1rem"
      size="2rem"
      inline
      onClick={onClick}
      {...props}
    >
      <InnerBox>{children}</InnerBox>
    </Box>
  );
}
